"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtmosphericCompression = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Tags_1 = require("../../../cards/Tags");
class AtmosphericCompression {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.ATMOSPHERIC_COMPRESSION;
        this.description = 'Decrease Venus 2 steps. Gain 1 TR if you have at least 3 Venus tags. Influence counts as Venus tags.';
        this.revealedDelegate = PartyName_1.PartyName.EMPOWER;
        this.currentDelegate = PartyName_1.PartyName.CENTRISTS;
    }
    resolve(game, turmoil) {
        game.increaseVenusScaleLevel(game.getPlayers()[0], -2);
        game.getPlayers().forEach((player) => {
            const venusTagCount = player.getTagCount(Tags_1.Tags.VENUS, 'raw') + turmoil.getPlayerInfluence(player);
            if (venusTagCount >= 3)
                player.increaseTerraformRating();
        });
    }
}
exports.AtmosphericCompression = AtmosphericCompression;
//# sourceMappingURL=AtmosphericCompression.js.map